import { anchor_children, app_anchor_children } from "./menus/index"
import { getOptDes } from "./menus/optDes"
const cxAnchorComponent = {
  name: "cxAnchorComponent",
  desc: "anchor样式",
  render: () => import("./render/index.vue"),
  optDes: getOptDes,
  enable: true,
  menus: {
    app: [
      {
        name: "锚点",
        children: app_anchor_children,
        group: "baseElement",
        thumbnail: "icon-portal-menu_anchor",
        enable(params) {
          let detailPageBusinessFlag = true
          if (params.detailPageBusinessFlag === false || params.listPageBusinessFlag === false) {
            detailPageBusinessFlag = false
          }
          return params.admin && !detailPageBusinessFlag
        },
        sort: 80
      }
    ],
    bigScreen: [],
    portal: [
      {
        name: "锚点",
        children: anchor_children,
        group: "baseElement",
        thumbnail: "icon-portal-menu_anchor",
        enable(params) {
          let detailPageBusinessFlag = true
          if (params.detailPageBusinessFlag === false || params.listPageBusinessFlag === false) {
            detailPageBusinessFlag = false
          }
          return params.admin && !detailPageBusinessFlag
        },
        sort: 80
      }
    ]
  },
  toolbars: [
    {
      name: "cxAnchorComponent",
      label: "锚点",
      comp: {
        anchorComponentData: () => import("./toolbars/anchor-options-data.vue"),
        anchorComponentSetting: () => import("./toolbars/anchor-options-setting.vue"),
        anchorComponentStyle: () => import("./toolbars/anchor-options-style.vue")
      }
    }
  ]
}

export default cxAnchorComponent
